import DatasourceTable from './DatasourceTable';
import SearchBy from './SearchBy';
export default {
  install(Vue) {
    Vue.component('datasource-table', DatasourceTable);
    Vue.component('search-by', SearchBy);
  },
};
